import { render, staticRenderFns } from "./CommunicationTest.vue?vue&type=template&id=1f5e4b69&scoped=true"
import script from "./CommunicationTest.vue?vue&type=script&lang=js"
export * from "./CommunicationTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e4b69",
  null
  
)

export default component.exports